import { useMutation, useQueryClient } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'

import type { ResearchReportDocument } from '@pepper/utils/src/types/seo'

interface Parameter {
  companyId: string
  reportId: string
  body: {
    document: Partial<ResearchReportDocument>
    length_scale_factor?: number
  }
}

export async function updateReport({ body, companyId, reportId }: Parameter) {
  const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/content-research/reports/${reportId}`
  try {
    const response = await axios.put(url, body)
    return extract.data<string>(response)
  } catch (error) {
    throw new Error(extract.error(error).error)
  }
}

export function useUpdateReport() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateReport,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(['research-report', variables.reportId])
      return true
    }
  })
}
